import { Dialog } from "@mui/material"
import { LoadingIndicator } from "../../components/loading-indicator.component"
import { DialogActionsBar } from "@progress/kendo-react-dialogs"
import { useAuthorize } from "../../hooks/use-authorize";
import { UserPermissionName } from "../../models/user-permission-name";

interface ConfirmDialogComponent {
    isLoading: boolean;
    isParentLoading: boolean;
    message?: string;
    onSubmit: () => void;
    onClosed: () => void;
}
export const ConfirmDialogComponent = ({ isLoading, isParentLoading, message, onSubmit, onClosed }: ConfirmDialogComponent) => {
    const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);
    return (
        <Dialog
            open={true}
            className="modalpopup"
            title='CONFIRM STATUS'
        // onClose={closeDialog}
        >
            <div>
                <div style={{ padding: '25px 50px' }}>
                    <div>
                        {message ?? "Are you sure you want to change the status?"}
                    </div>
                    <LoadingIndicator isLoading={isLoading} />
                </div>
            </div>
            <DialogActionsBar>
                <div className=" spaceBetween">
                    <button
                        style={{ cursor: 'pointer' }}
                        className="btn btn-sm btn-default btn-lightGrey"
                        onClick={onClosed}
                        autoFocus
                    >
                        Cancel
                    </button>
                    <button
                        className="btn btn-sm btn-primary  btn-delete"
                        style={{
                            backgroundColor: isReadOnlyPermission ? '#d7dbdd' : '#0000b5',
                            color: isReadOnlyPermission ? 'black' : '#fff',
                            cursor: 'pointer'
                        }}
                        type="button"
                        onClick={onSubmit}
                        disabled={isParentLoading || isReadOnlyPermission}
                    >
                        Confirm
                    </button>
                </div>
            </DialogActionsBar>
        </Dialog>
    )
}